import React, { Component } from 'react';
import powerPlatformImage from '../../../media/images/powerplatform.jpg';
import powerPlatformMobileImage from '../../../media/images/powerplatformMobile.jpg';
import platformImage from '../../../media/images/platform.png';
import MetaDecorator from '../../services/MetaDecorator';

export default class PowerPlatform extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth
        };
    }
    componentDidMount = () => {
        const { width } = this.state;
        const isMobile = width <= 600;
        const isTablet = width <= 992 && width > 600;

        let tabs = document.getElementsByClassName("nav-wrapper");
        if (tabs.length > 0) {
            tabs = tabs[1].querySelectorAll("ul")[0].querySelectorAll("a");
            for (let i = 0; i < tabs.length; i++) {
                tabs[i].removeAttribute('class');
                if (tabs[i].id === "scopes" || tabs[i].id === "powerplatform") {
                    tabs[i].setAttribute('class', 'orange-text text-darken-4')
                }
            }
        }
        let mobileTabs = document.getElementsByClassName("sidenav");
        if (mobileTabs.length > 0) {
            mobileTabs = mobileTabs[0].querySelectorAll("a");
            for (let i = 0; i < mobileTabs.length; i++) {
                if (mobileTabs[i].id === "scopesMobile" || mobileTabs[i].id === "powerplatformMobile") {
                    mobileTabs[i].removeAttribute('class');
                    mobileTabs[i].setAttribute('class', 'orange-text text-darken-4 grey darken-3')
                }
            }
        }
        if (isMobile || isTablet) {
            let subTabs = document.getElementsByClassName("tabs");
            if (subTabs.length > 0) {
                subTabs = subTabs[0].querySelectorAll("a");
                for (let i = 0; i < subTabs.length; i++) {
                    if (subTabs[i].id === "powerplatformTab") {
                        subTabs[i].scrollIntoView();
                        window.scrollTo(0, 0);
                    }
                }
            }
        }
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth });
    }

    render() {
        const { width } = this.state;
        const isMobile = width <= 600;
        const isTablet = width <= 992 && width > 600;
        return (
            <React.Fragment>
                <MetaDecorator
                    title="JetMinds | Power Platform Beratung, Konzeption und Entwicklung"
                    descrption="Gemeinsames Arbeiten mit effektiven Lösungen für automatisierte Arbeitsabläufe, Datenanalysen, Business Apps & Bots können wir Ihnen in Kombination mit der Power Platform anbieten"
                    url="https://www.jetminds.de/fokusbereiche/power-platform/"
                />
                <div className="pageImageTitle">
                    {isMobile ?
                        <img className="responsive-img" style={{ width: '100%' }} src={powerPlatformMobileImage} alt="JetMinds Microsoft Power Platform" loading="lazy" /> :
                        <img className="responsive-img" style={{ width: '100%' }} src={powerPlatformImage} alt="JetMinds Microsoft Power Platform" loading="lazy" />}
                    {isMobile || isTablet ?
                        <div className="imgTxtMobile">
                            <h1 className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}>Power Platform</h1>
                        </div>
                        :
                        <div className="imgTxt">
                            <h1 className="white-text">Power Platform</h1>
                        </div>}
                </div>
                <div className="container">
                    <div className="section">
                        <div className="row">
                            <div className="col s12 m12">
                                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`} >Microsoft <span className="orange-text text-darken-4">Power Platform</span> - "Adapt. Now more than ever"</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col s12 m12">
                                <p className="light">Moderne Unternehmen arbeiten mit Daten. Ihre Mitarbeiter interagieren täglich mit Daten, zum Beispiel, wenn sie ihre Projektdokumente für die Abrechnung erfassen, sich über vorhandene Prozesse informieren oder Daten für die Entscheidungsfindung analysieren. In unserer technologiegesteuerten Welt von heute haben Mitarbeiter die Möglichkeit, Einblicke in Daten zu gewinnen und mit diesen zu interagieren, während sie zugleich grundlegende Aufgaben automatisieren, die eher eine Belastung als sinnvolle Tätigkeit sind. Wir helfen Ihrem Unternehmen Lösungen auf Basis von Power Platform zu entwickeln und maßgeschneiderte Technologien zu implementieren, um allen – von der Geschäftsführung bis hin zum einzelnen Mitarbeiter im Außendienst – dabei zu helfen, das Unternehmen mit automatisierten Geschäftsprozessen voranzutreiben.</p>
                            </div>
                        </div>
                        <div className="section">
                            <div className="row">
                                <div className={`col s12 ${isTablet ? "m12" : "m8"}`}>
                                    <p className="light">Die Digitalisierung von Geschäftsprozessen und Workflows stellt Unternehmen vor eine große und zugleich unverzichtbare Herausforderung. Nur diejenigen Unternehmen, die aus dem ständig wachsenden Berg gesammelter Daten Wissen gewinnen und mithilfe automatisierter Geschäftsprozesse Effizienzgewinne erzielen, werden langfristig überleben.</p>
                                    <p className="light">Power Platform entwickelt seine Stärke durch die Fähigkeit, Daten auf vielen Plattformen zu nutzen. Dazu verwenden Komponenten von Power Platform Konnektoren wie z. B. Salesforce, Dropbox, Adobe oder SAP. Sie können von mehr als 275 Konnektoren profitieren, die als Brücke zwischen Ihrer Datenquelle und Ihrer App bzw. Ihrem Workflow verwendet werden und Informationen hin und her übertragen und austauschen.</p>
                                </div>
                                <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                                    <img className="responsive-img" src={platformImage} alt="JetMinds Microsoft Power Platform" loading="lazy" />
                                </div>
                            </div>
                        </div>
                        <div className="section">
                            <div className="row">
                                <div className="col s12 m12">
                                    <blockquote className="powerapps">
                                        <p className="light">
                                            <b>Power Apps</b> bietet eine schnelle Low-Code-Entwicklungsumgebung zum Erstellen benutzerdefinierter Apps für geschäftliche Anforderungen. Es verfügt über Dienste, Konnektoren sowie einen skalierbaren Datendienst und eine App-Plattform (Common Data Service), um eine einfache Integration und Interaktion mit vorhandenen Daten zu ermöglichen. Power Apps ermöglicht die Erstellung von Web- und Mobilanwendungen, die auf allen Geräten ausgeführt werden.
                                        </p>
                                        <p className="light">
                                            Die Menschen nutzen Apps für jeden Bereich ihres Lebens, und das sollte auch im Geschäftsleben nicht anders sein. Die meisten Standardlösungen erfüllen nicht genau die geschäftsspezifischen Anforderungen oder lassen sich nicht gut in andere Geschäftsprogramme integrieren. Wir helfen Ihnen mit Power Apps bei schnellen und effizienten maßgeschneiderten Entwicklungen, die Ihren Anforderungen und Wünschen entsprechen.
                                        </p>
                                    </blockquote>
                                </div>
                                <div className="col s12 m12">
                                    <blockquote className="powerautomate">
                                        <p className="light">
                                            Mit <b>Power Automate</b> können Workflows bzw. wiederholende Geschäftsprozesse wie Kommunikation, Datenerfassungen und Entscheidungsgenehmigungen zwischen Anwendungen und Diensten automatisiert werden. Verschwenden Sie keine wichtigen produktiven Stunden damit, dieselbe E-Mail für ein wöchentliches Update zu verfassen oder Genehmigungen durchzugehen.
                                        </p>
                                        <p className="light">
                                            Mit Power Automate garantieren wir unseren Kunden Zeit und viel Routinearbeit einzusparen. Wir bieten Ihnen eine sehr leistungsstarke Automatisierung durch digitale Workflows und intelligente RPA (Robotic Process Automation). Automatisieren Sie zeitaufwändige manuelle Aufgaben mit integrierten KI-Funktionen, damit Sie mehr Zeit haben, sich auf strategische, kreative Möglichkeiten zu konzentrieren.
                                        </p>
                                    </blockquote>
                                </div>
                                <div className="col s12 m12">
                                    <blockquote className="powerbi">
                                        <p className="light">
                                            <b>Power BI</b>, Business Intelligence, ist ein Analytics-Service, der Erkenntnisse für die Analyse von Daten bereitstellt. Er kann diese Erkenntnisse durch Datenvisualisierungen freigeben, Berichte und Dashboards bilden, um schnelle und fundierte Entscheidungen zu ermöglichen. Power BI ist für die gesamte Organisation skalierbar und bietet integrierte Governance und Sicherheit, sodass sich Unternehmen mehr auf die Verwendung von Daten als auf deren Verwaltung konzentrieren.
                                    </p>
                                        <p className="light">
                                            Sie können Power BI als die aufschlussreiche Analyse der Power Platform betrachten. Es nutzt Geschäftsdaten und ermöglicht es Ihnen, diese auf eine Art und Weise anzuzeigen, die für Benutzer am sinnvollsten ist. Ein Power BI-Dashboard kann möglicherweise eine ständige Besprechung ersetzen, bei der über Unternehmenskennzahlen wie Verkaufsdaten, Fortschritte im Hinblick auf Ziele oder Mitarbeiterleistung berichtet wird.
                                    </p>
                                    </blockquote>
                                </div>
                                <div className="col s12 m12">
                                    <blockquote className="powervirtualagent">
                                        <p className="light">
                                            Mit <b>Power Virtual Agents</b> können wir leistungsstarke Chatbots für Ihr Unternehmen erstellen, die es Mitarbeitern ermöglichen, über KI-Konversationsfunktionen und umfassende und natürliche Dialoge zu verfügen, die sie schnell zur richtigen und intelligenten Lösung führen. Mit Power Virtual Agents können Sie mithilfe leistungsfähiger Metriken und AI-gesteuerter Dashboards die Leistung Ihrer Bots im Auge behalten.
                                        </p>
                                        <p className="light">
                                            Mit Power Virtual Agents können Sie mit Power Automate problemlos sofort in Services und Back-End-Systeme integrieren oder über Hunderte von benutzerdefinierten Konnektoren hinzufügen. Sie können Customer Service Insights in Dynamics 365 und Power Virtual Agents zusammen verwenden, um zu bestimmen, welche Themen im Trend liegen oder Supportressourcen verbrauchen, und diese dann einfach zu automatisieren.
                                        </p>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                        <div className="section">
                            <div className="row center">
                                <div className="col s12 m12">
                                    <a href="/kontakt" className="btn-large orange darken-4">Jetzt beraten lassen<i className="material-icons right" style={{ fontSize: "20px" }}>arrow_forward</i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/pages/PowerPlatform.js